import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Table } from "react-bootstrap";
import { db } from "../FireBase";
import { collection, query, where, getDocs,getDoc, addDoc,updateDoc ,serverTimestamp,doc} from 'firebase/firestore';
import ManualPaymentModal from '../components/ManualPaymentModal';
import ToastAlert from '../components/ToastAlert';
import Loading from '../components/Loading';
import { v4 as uuidv4 } from "uuid";

const DataEntry = () => {
    const [loading, setLoading] = useState(true);
    const [schemes, setSchemes] = useState([]);
    const [selschemes, setSelSchemes] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [settedScheme, setSettedScheme] = useState(null);

    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);

    const [allCustomers, setAllCustomers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [customerQuantities, setCustomerQuantities] = useState({});
     
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
      const [searchTerm1, setSearchTerm1] = useState("");
      const [loadingSchemeId, setLoadingSchemeId] = useState(null);
      


    useEffect(() => {
        const fetchSchemeDetails = async () => {
            try {
                setLoading(true);
                const activeSchemesQuery = query(
                    collection(db, 'schemes'),
                    where('status', '!=', 'Completed')
                    );

                    const schemesSnapshot = await getDocs(activeSchemesQuery);


              
                if (!schemesSnapshot.empty) {
                    const filteredSchemes = schemesSnapshot.docs
                        .map(doc => ({
                        id: doc.id,
                        ...doc.data()
                        }))
                        .filter(scheme => scheme.deleted !== true); // allows false or undefined

                    setSchemes(filteredSchemes);
                }
                else {
                    console.log('No active schemes found');
                }
               
            } catch (error) {
                console.error('Error fetching active schemes:', error);
                
            }finally{
                setLoading(false);
            }

        };
       
        fetchSchemeDetails();
    }, []);

    useEffect(()=>{
        fetchSelScheme();
        console.log(settedScheme)
    },[settedScheme]);

    const fetchSelScheme = async () => {
        try {
            console.log("fetchSelScheme get d",settedScheme)
            setLoading(true);
            const schemeDocRef = doc(db, 'schemes', settedScheme);
            const schemeSnapshot = await getDoc(schemeDocRef);
    
            if (schemeSnapshot.exists()) {
                setSelSchemes({ id: schemeSnapshot.id, ...schemeSnapshot.data() });
            } else {
                console.log('No active schemes found');
                setSelSchemes(null);
            }
           
        } catch (error) {
            console.error('Error fetching selected scheme:', error);
           
        }finally{
            setLoading(false);
        }
    };

    const fetchPaymentData = async (schemeId) => {
    try {
        setSettedScheme(schemeId);
        setLoading(true);

        // Step 1: Fetch subscriptions for schemeId
        const subscriptionQuery = query(
            collection(db, "subscriptions"),
            where("schemeId", "==", schemeId)
        );
        const subscriptionSnapshot = await getDocs(subscriptionQuery);

        if (subscriptionSnapshot.empty) {
            console.log("No matching subscriptions found for schemeId:", schemeId);
            setToastMessage('No customers found for this scheme. Please import customers first.');
            setToastVariant('warning');
            setShowToast(true);
            return;
        }

        // Step 2: Filter out discontinued subscriptions
        const validSubscriptions = subscriptionSnapshot.docs.filter(doc => {
            const data = doc.data();
            return !data.status || data.status !== "discontinued"; 
            // ✅ includes subscriptions with no status
        });

        if (validSubscriptions.length === 0) {
            console.log("All subscriptions are discontinued for schemeId:", schemeId);
            setToastMessage('No active customers found for this scheme.');
            setToastVariant('warning');
            setShowToast(true);
            return;
        }

        // Step 3: Extract customer IDs
        const customerIds = validSubscriptions.map(doc => doc.data().userId);
        let customersData = [];

     // Step 3 & 4: Build customers list WITH subscriptionId


        for (const subDoc of validSubscriptions) {
            const subData = subDoc.data();

            const userQuery = query(
                collection(db, "users"),
                where("cusmid", "==", subData.userId)
            );

            const userSnapshot = await getDocs(userQuery);

            userSnapshot.forEach(userDoc => {
                customersData.push({
                    id: userDoc.id,
                    ...userDoc.data(),

                    // ✅ ADD THESE (IMPORTANT)
                    subscriptionId: subData.subscriptionId,
                    quantity: subData.quantity,
                    schemeId: subData.schemeId
                });
            });
        }


        console.log("Fetched customers:", customersData);
        setCustomers(customersData);
        setShowPaymentModal(true);

    } catch (error) {
        console.error("Error fetching payment data:", error);
        setToastMessage("Failed to fetch payment data.");
        setToastVariant("danger");
        setShowToast(true);
    } finally {
        setLoading(false);
    }
};


    const fetchAllCustomers = async (schemeId) => {
        try {
            console.log(schemeId)
            if (!schemeId) {
               
                setToastMessage('No scheme seleted!');
                setToastVariant('warning');
                setShowToast(true);
                return;
            }

            setSettedScheme(schemeId); // ✅ Set scheme before opening modal
            setLoading(true);
            const usersSnapshot = await getDocs(collection(db, "users"));
            const usersData = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAllCustomers(usersData);
            setShowImportModal(true);
           
            
        } catch (error) {
            console.error("Error fetching users:", error);
           
        }finally{
            setLoading(false);
        }
    };

    const handleCustomerSelection = (id) => {
        setSelectedCustomers(prev =>
            prev.includes(id) ? prev.filter(uid => uid !== id) : [...prev, id]
        );
    };

    const handleQuantityChange = (id, quantity) => {
        setCustomerQuantities(prev => ({ ...prev, [id]: quantity }));
    };


   const handleImportCustomers = async () => {
  if (!settedScheme) {
    setToastMessage('No scheme selected!');
    setToastVariant('warning');
    setShowToast(true);
    return;
  }

  try {
    setLoading(true);

    for (const customerId of selectedCustomers) {
      const quantity = parseInt(customerQuantities[customerId] || 1);

      const payments = [];
      const subscriptionId = `SUB-${uuidv4().replace(/-/g, "").slice(0, 12).toUpperCase()}`;
      const startDate = new Date(selschemes.SchemeStart);

      for (let i = 0; i < selschemes.schemeDuration; i++) {
        const paymentDate = new Date(startDate);
        paymentDate.setMonth(startDate.getMonth() + i);

        payments.push({
          month: paymentDate.toISOString().split('T')[0].slice(0, 7), // YYYY-MM
          monthName: paymentDate.toLocaleString('default', { month: 'long' }),
          year: paymentDate.getFullYear(),
          paymentStatus: "Pending",
          paidTimestamp: null,
        });
      }

      await addDoc(collection(db, 'subscriptions'), {
        createdAt: serverTimestamp(),
        userId: customerId,
        schemeId: settedScheme,
        subscriptionId,
        startDate,
        SchemeStart: selschemes.SchemeStart,
        monthlyDue: selschemes.price,
        monthlyPayment: selschemes.price * quantity,
        totalMonths: selschemes.schemeDuration,
        paidMonths: 0,
        isActive: true,
        LateFee: true,
        deliveryStatus: '',
        payments,
        quantity,
        status: true,
      });
    }

    setToastMessage('Customers imported successfully!');
    setToastVariant('success');
    setShowToast(true);

    setShowImportModal(false);
    setSelectedCustomers([]);

  } catch (error) {
    console.error("Error importing customers:", error);
    setToastMessage('Something went wrong while importing customers');
    setToastVariant('danger');
    setShowToast(true);
  } finally {
    setLoading(false);
  }
};


    const filteredCustomers = allCustomers.filter(customer =>
        customer.name?.toLowerCase().includes(searchTerm.toLowerCase())||
        customer.phone?.toLowerCase().includes(searchTerm.toLowerCase())||
        customer.address?.area?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (loading) {
        // Render loading screen
        
        return (
          <div className="loading-screen">
            
          <Loading/>
          </div>
        );
      }
 
    return (
        <div className="data-entry">
              <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
            <h1>Data Entry</h1>
            <Form.Control
                    type="text"
                    placeholder="Search schemes..."
                    value={searchTerm1}
                    onChange={(e) => setSearchTerm1(e.target.value)}
                    className="mb-3"
                />
            <Table striped bordered hover responsive>
                <thead>
                    <tr className='scheme-det-font-head'>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {schemes
                    .filter((scheme) =>
                        scheme.name.toLowerCase().includes(searchTerm1.toLowerCase())||
                        scheme.id.toLowerCase().includes(searchTerm1.toLowerCase())
                    )
                    .map((scheme,index) => (
                        <tr key={index} className='scheme-det-font'>
                            <td>{scheme.id}</td>
                            <td>{scheme.name}</td>
                            <td>
                            <Button
                                variant="outline-success"
                                className="btn me-2"
                                onClick={() => {
                                    setLoadingSchemeId(scheme.id);
                                    fetchPaymentData(scheme.id).finally(() => setLoadingSchemeId(null));
                                }}
                                disabled={loadingSchemeId === scheme.id}
                                >
                                {loadingSchemeId === scheme.id ? (
                                    <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Fetching data...
                                    </>
                                ) : (
                                    'Manual Payment Entry'
                                )}
                                </Button>

                                <Button variant="outline-primary" className="btn"
                                    onClick={() => fetchAllCustomers(scheme.id)}>
                                    Import Customers
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <ManualPaymentModal
                show={showPaymentModal}
                onHide={() => setShowPaymentModal(false)}
                schemeId={settedScheme}
                customers={customers}
            />

            {/* Import Customers Modal */}
            <Modal show={showImportModal} onHide={() => setShowImportModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Import Customers</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control
                        type="text"
                        placeholder="Search customers by name phone,area"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Table striped bordered hover responsive className="mt-3">
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Area</th>
                                <th>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredCustomers.map(customer => (
                                <tr key={customer.cusmid}>
                                    <td>
                                        <Form.Check
                                            type="checkbox"
                                            checked={selectedCustomers.includes(customer.cusmid)}
                                            onChange={() => handleCustomerSelection(customer.cusmid)}
                                        />
                                    </td>
                                    <td>{customer.cusmid}</td>
                                    <td>{customer.name}</td>
                                    <td>{customer.phone}</td>
                                    <td>{customer.address?.area}</td>
                                    <td>
                                        <Form.Control
                                            type="number"
                                            min="1"
                                            value={customerQuantities[customer.cusmid] || 1}
                                            onChange={(e) => handleQuantityChange(customer.cusmid, e.target.value)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowImportModal(false)}>Close</Button>
                    <Button variant="primary" onClick={handleImportCustomers}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DataEntry;
